<div class="container">
  <img src="assets/img/Reval.png" alt="Reval logo">
  <h1>Property Import Guide</h1>
  <hr />
  <p class="intro bold-font">
    Below is a list of the fields included in the upload template, an explanation of their
    purpose and any limitations on the data that the fields can include.
  </p>

  <table class="property-table">
    <thead>
      <tr>
        <th>Field</th>
        <th>Description</th>
        <th>Data Type</th>
        <th>Mandatory?</th>
        <th>Data Options</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>External Reference</td>
        <td>An unique identifier for this property.</td>
        <td>Text</td>
        <td><i>No</i></td>
        <td></td>
      </tr>
      <tr>
        <td>Original Price</td>
        <td>The original price of the property.</td>
        <td>Number</td>
        <td><i>No</i></td>
        <td>If provided then the value must be equal to or greater than zero.</td>
      </tr>
      <tr>
        <td>Original Price Date</td>
        <td>The date the Original Price was achieved.</td>
        <td>Text</td>
        <td><strong>Yes if Original Price is provided</strong></td>
        <td>Formatted as <i>dd/mm/yyyy</i></td>
      </tr>
      <tr>
        <td>Construction Type</td>
        <td>The construction medium for the property</td>
        <td>Text</td>
        <td><strong>Yes</strong></td>
        <td>
          Available options:
          <ul>
            <li><code>Brick</code></li>
            <li><code>Wood</code></li>
            <li><code>Other</code></li>
          </ul>
        </td>
      </tr>
      <tr>
        <td>Property Type</td>
        <td>The type of property being valued.</td>
        <td>Text</td>
        <td><strong>Yes</strong></td>
        <td>
          Available options:
          <ul>
            <li><code>Semi-Detached</code></li>
            <li><code>Detached</code></li>
            <li><code>Mid-Terrace</code></li>
            <li><code>Apartment</code></li>
            <li><code>Garage</code></li>
          </ul>
        </td>
      </tr>
      <tr>
        <td>Asset Origin</td>
        <td>Source of the property acquisition.</td>
        <td>Text</td>
        <td><strong>Yes</strong></td>
        <td>
          Available options:
          <ul>
            <li><code>Development</code></li>
            <li><code>Purchase</code></li>
            <li><code>Gift</code></li>
          </ul>
        </td>
      </tr>
      <tr>
        <td>Build Date</td>
        <td>The date which the property was built.</td>
        <td>Text</td>
        <td><strong>Yes</strong></td>
        <td>Formatted as <i>dd/mm/yyyy</i></td>
      </tr>
      <tr>
        <td>Date Received</td>
        <td>The date which the property was acquired.</td>
        <td>Text</td>
        <td><strong>Yes</strong></td>
        <td>Formatted as <i>dd/mm/yyyy</i></td>
      </tr>
      <tr>
        <td>Owning Body</td>
        <td>The Owning Body for this property.</td>
        <td>Text</td>
        <td><i>No</i></td>
        <td>
          <p>Maxmimum 100 characters in length.</p>
        </td>
      </tr>
      <tr>
        <td>Bedrooms</td>
        <td>The number of bedrooms within the property.</td>
        <td>Number</td>
        <td><i>No</i></td>
        <td>If provided then the value must be equal to or greater than zero.</td>
      </tr>
      <tr>
        <td>Condition</td>
        <td>Indicates the overall condition of the property.</td>
        <td>Text</td>
        <td><strong>Yes</strong></td>
        <td>
          Available options:
          <ul>
            <li><code>Good</code></li>
            <li><code>Average</code></li>
            <li><code>Bad</code></li>
            <li><code>Un-Modernised</code></li>
            <li><code>Very Good</code></li>
          </ul>
        </td>
      </tr>
      <tr>
        <td>Financing Instrument Name</td>
        <td>The Financial Instrument associated with the purchase of this property.</td>
        <td>Text</td>
        <td><strong>Yes</strong></td>
        <td>Must be one of the Financial Instrument External Reference values from the Reval Configuration.</td>
      </tr>
      <tr>
        <td>Tenants Rights</td>
        <td>The tenants' rights associated with the property.</td>
        <td>Text</td>
        <td><strong>Yes</strong></td>
        <td>
          Available options:
          <ul>
            <li><code>Right to buy</code></li>
            <li><code>Right to acquire</code></li>
            <li><code>None</code></li>
            <li><code>Shared ownership</code></li>
          </ul>
        </td>
      </tr>
      <tr>
        <td>Line 1</td>
        <td>The property address line 1.</td>
        <td>Text</td>
        <td><i>No</i></td>
        <td>
          <p>Maxmimum 100 characters in length.</p>
        </td>
      </tr>
      <tr>
        <td>Line 2</td>
        <td>The property address line 2.</td>
        <td>Text</td>
        <td><i>No</i></td>
        <td>
          <p>Maxmimum 100 characters in length.</p>
        </td>
      </tr>
      <tr>
        <td>Line 3</td>
        <td>The property address line 3.</td>
        <td>Text</td>
        <td><i>No</i></td>
        <td>
          <p>Maxmimum 100 characters in length.</p>
        </td>
      </tr>
      <tr>
        <td>Line 4</td>
        <td>The property address line 4.</td>
        <td>Text</td>
        <td><i>No</i></td>
        <td>
          <p>Maxmimum 100 characters in length.</p>
        </td>
      </tr>
      <tr>
        <td>Line 5</td>
        <td>The property address line 5.</td>
        <td>Text</td>
        <td><i>No</i></td>
        <td>
          <p>Maxmimum 100 characters in length.</p>
        </td>
      </tr>
      <tr>
        <td>Post Code</td>
        <td>The postcode for the property.</td>
        <td>Text</td>
        <td><strong>Yes</strong></td>
        <td>
          <p>Maxmimum 10 characters in length.</p>
        </td>
      </tr>
      <tr>
        <td>Region</td>
        <td>The geographic region for the property. Used by the Formula Rent valution method.</td>
        <td>Text</td>
        <td><strong>Yes</strong></td>
        <td>
          Available options:
          <ul class="multi-column">
            <li><code>Avon</code></li>
            <li><code>Bedfordshire</code></li>
            <li><code>Berkshire</code></li>
            <li><code>Buckinghamshire</code></li>
            <li><code>Cambridgeshire</code></li>
            <li><code>Cheshire</code></li>
            <li><code>Cleveland</code></li>
            <li><code>Cornwall</code></li>
            <li><code>Cumbria</code></li>
            <li><code>Derbyshire</code></li>
            <li><code>Devon</code></li>
            <li><code>Dorset</code></li>
            <li><code>Durham</code></li>
            <li><code>East Sussex</code></li>
            <li><code>Essex</code></li>
            <li><code>Gloucestershire</code></li>
            <li><code>Greater London</code></li>
            <li><code>Greater Manchester</code></li>
            <li><code>Hampshire</code></li>
            <li><code>Hereford & Worcestershire</code></li>
            <li><code>Hertfordshire</code></li>
            <li><code>Humberside</code></li>
            <li><code>Isle of Wight</code></li>
            <li><code>Kent</code></li>
            <li><code>Lancashire</code></li>
            <li><code>Leicestershire</code></li>
            <li><code>Lincolnshire</code></li>
            <li><code>Merseyside</code></li>
            <li><code>Norfolk</code></li>
            <li><code>North Yorkshire</code></li>
            <li><code>Northamptonshire</code></li>
            <li><code>Northumberland</code></li>
            <li><code>Nottinghamshire</code></li>
            <li><code>Oxfordshire</code></li>
            <li><code>Shropshire</code></li>
            <li><code>Somerset</code></li>
            <li><code>South Yorkshire</code></li>
            <li><code>Staffordshire</code></li>
            <li><code>Suffolk</code></li>
            <li><code>Surrey</code></li>
            <li><code>Tyne & Wear</code></li>
            <li><code>Warwickshire</code></li>
            <li><code>West Midlands</code></li>
            <li><code>West Sussex</code></li>
            <li><code>West Yorkshire</code></li>
            <li><code>Wiltshire</code></li>
            <li><code>Derry</code></li>
            <li><code>Londonderry</code></li>
            <li><code>Antrim</code></li>
            <li><code>Tyrone</code></li>
            <li><code>Down</code></li>
            <li><code>Armagh</code></li>
            <li><code>Fermanagh</code></li>
            <li><code>Cavan</code></li>
            <li><code>Donegal</code></li>
            <li><code>Monaghan</code></li>
            <li><code>Cork</code></li>
            <li><code>Kerry</code></li>
            <li><code>Clare</code></li>
            <li><code>Limerick</code></li>
            <li><code>Tipperary</code></li>
            <li><code>Waterford</code></li>
            <li><code>Carlow</code></li>
            <li><code>Dublin</code></li>
            <li><code>Kildare</code></li>
            <li><code>Kilkenny</code></li>
            <li><code>Laois</code></li>
            <li><code>Longford</code></li>
            <li><code>Louth</code></li>
            <li><code>Meath</code></li>
            <li><code>Offaly</code></li>
            <li><code>Westmeath</code></li>
            <li><code>Wexford</code></li>
            <li><code>Wicklow</code></li>
            <li><code>Sligo</code></li>
            <li><code>Mayo</code></li>
            <li><code>Galway</code></li>
            <li><code>Leitrim</code></li>
            <li><code>Roscommon</code></li>
            <li><code>Unknown-UK</code></li>
            <li><code>Unknown-Republic of Ireland</code></li>
            <li><code>Unknown-Northern Ireland</code></li>
            <li><code>Aberdeenshire</code></li>
            <li><code>Angus</code></li>
            <li><code>Argyll</code></li>
            <li><code>Ayrshire</code></li>
            <li><code>Banffshire</code></li>
            <li><code>Berwickshire</code></li>
            <li><code>Buteshire</code></li>
            <li><code>Caithness</code></li>
            <li><code>Clackmannanshire</code></li>
            <li><code>Dumfriesshire</code></li>
            <li><code>Dunbartonshire</code></li>
            <li><code>East Lothian</code></li>
            <li><code>Fife</code></li>
            <li><code>Inverness-shire</code></li>
            <li><code>Kincardineshire</code></li>
            <li><code>Kinross-shire</code></li>
            <li><code>Kirkcudbrightshire</code></li>
            <li><code>Lanarkshire</code></li>
            <li><code>Midlothian</code></li>
            <li><code>Moray</code></li>
            <li><code>Nairnshire</code></li>
            <li><code>Orkney</code></li>
            <li><code>Peebleshire</code></li>
            <li><code>Perthshire</code></li>
            <li><code>Renfrewshire</code></li>
            <li><code>Ross and Cromarty</code></li>
            <li><code>Roxburghshire</code></li>
            <li><code>Selkirkshire</code></li>
            <li><code>Shetland</code></li>
            <li><code>Stirlingshire</code></li>
            <li><code>Sutherland</code></li>
            <li><code>West Lothian</code></li>
            <li><code>Wigtownshire</code></li>
            <li><code>Isle of Anglesey</code></li>
            <li><code>Gwynedd</code></li>
            <li><code>Conwy</code></li>
            <li><code>Denbighshire</code></li>
            <li><code>Flintshire</code></li>
            <li><code>Wrexham</code></li>
            <li><code>Ceredigion</code></li>
            <li><code>Powys</code></li>
            <li><code>Pembrokeshire</code></li>
            <li><code>Carmarthenshire</code></li>
            <li><code>Swansea</code></li>
            <li><code>Neath Port Talbot</code></li>
            <li><code>Bridgend</code></li>
            <li><code>Vale of Glamorgan</code></li>
            <li><code>Rhondda Cynon Taff</code></li>
            <li><code>Cardiff</code></li>
            <li><code>Merthyr Tydfil</code></li>
            <li><code>Caerphilly</code></li>
            <li><code>Newport</code></li>
            <li><code>Torfaen</code></li>
            <li><code>Blaenau Gwent</code></li>
            <li><code>Monmouthshire</code></li>
          </ul>
        </td>
      </tr>
      <tr>
        <td>Country</td>
        <td>The country in which the property is located.</td>
        <td>Text</td>
        <td><strong>Yes</strong></td>
        <td>
          <p>This value should be set according to the region above.</p>
          <p>Available options:</p>
          <ul>
            <li><code>UK</code></li>
            <li><code>Republic of Ireland</code></li>
            <li><code>England</code></li>
            <li><code>Northern Ireland</code></li>
            <li><code>Scotland</code></li>
            <li><code>Wales</code></li>
          </ul>
        </td>
      </tr>
      <tr>
        <td>Longitude</td>
        <td>The longitude coordinate of the property.</td>
        <td>Number</td>
        <td><i>No</i></td>
        <td>Must be between -180 and 180.</td>
      </tr>
      <tr>
        <td>Latitude</td>
        <td>The latitude coordinate of the property.</td>
        <td>Number</td>
        <td><i>No</i></td>
        <td>Must be between -90 and 90.</td>
      </tr>
      <tr>
        <td>Last Valuation</td>
        <td>The most recent valuation amount for the property.</td>
        <td>Number</td>
        <td><i>No</i></td>
        <td>
          <p>If provided then the value must be equal to or greater than zero.</p>
        </td>
      </tr>
      <tr>
        <td>Last Valuation Date</td>
        <td>The date of the most recent valuation.</td>
        <td>Text</td>
        <td><i>No</i></td>
        <td>
          <p>Formatted as <i>dd/mm/yyyy</i></p>
        </td>
      </tr>
      <tr>
        <td>Market Rent</td>
        <td>The <strong>annual</strong> estimated amount that the property could be rented for in the current market
          conditions.</td>
        <td>Number</td>
        <td><i>No</i></td>
        <td>
          <p>If provided then the value must be equal to or greater than zero.</p>
        </td>
      </tr>
      <tr>
        <td>Achieved Rent</td>
        <td>The actual <strong>annual</strong> amount that is being paid by the tenant for the property.</td>
        <td>Number</td>
        <td><i>No</i></td>
        <td>
          <p>If provided then the value must be equal to or greater than zero.</p>
        </td>
      </tr>
      <tr>
        <td>Social Rent</td>
        <td>The <strong>annual</strong> social rent figure for the property, used in Social Housing EUV calculations.
        </td>
        <td>Number</td>
        <td><i>No</i></td>
        <td>If provided then the value must be equal to or greater than zero.</td>
      </tr>
      <tr>
        <td>Affordable Rent</td>
        <td>The <strong>annual</strong> affordable rent figure for the property, used in Affordable Housing EUV
          calculations.</td>
        <td>Number</td>
        <td><i>No</i></td>
        <td>If provided then the value must be equal to or greater than zero.</td>
      </tr>
      <tr>
        <td>Internal Area Sqft</td>
        <td>The internal area of the property measured square feet.</td>
        <td>Number</td>
        <td><i>No</i></td>
        <td>
          <p>If provided then the value must be equal to or greater than zero.</p>
        </td>
      </tr>
      <tr>
        <td>Tenant Rights Qualification Date</td>
        <td>The start date from which any RTA / RTB / Shared Ownership benefits are calculated.</td>
        <td>Text</td>
        <td><i>No</i></td>
        <td>
          <p>Formatted as <i>dd/mm/yyyy</i></p>
        </td>
      </tr>
      <tr>
        <td>Garden Size</td>
        <td>An indication of the size of the property's main garden area.</td>
        <td>Text</td>
        <td><i>No</i></td>
        <td>
          Available options:
          <ul>
            <li>
              <code>None</code>
            </li>
            <li>
              <code>Less than 0.1 Acres</code>
            </li>
            <li>
              <code>0.1 - 0.5 Acres</code>
            </li>
            <li>
              <code>0.5 - 1.0 Acres</code>
            </li>
            <li>
              <code>Above 1.0 Acres</code>
            </li>
          </ul>
        </td>
      </tr>
      <tr>
        <td>Significant View</td>
        <td>An indication of the views available from the property.</td>
        <td>Text</td>
        <td><i>No</i></td>
        <td>
          <p>Available options:</p>
          <ul>
            <li>
              <code>Normal</code>
            </li>
            <li>
              <code>Good</code>
            </li>
            <li>
              <code>Excellent</code>
            </li>
          </ul>
        </td>
      </tr>
      <tr>
        <td>Shared Ownership Percent</td>
        <td>The percentage of the shared ownership tenancy agreement owned by the tenant.</td>
        <td>Number</td>
        <td><i>No</i></td>
        <td>
          <p>Must be between 0 and 100.</p>
        </td>
      </tr>
      <tr>
        <td>RTA Discount Location</td>
        <td>The location for which the Right-To-Acquire discount should be obtained.</td>
        <td>Text</td>
        <td><i>No</i></td>
        <td>
          <p>Available options - do not use the value displayed in the brackets:</p>
          <ul>
            <li>
              <code>Bath and North East Somerset</code>
            </li>
            <li><i>(Bedfordshire)</i>
              <code>Bedford</code>,
              <code>Mid Bedfordshire</code>,
              <code>South Bedfordshire</code>
            </li>
            <li><i>(Berkshire)</i>
              <code>Reading</code>,
              <code>Slough</code>,
              <code>Windsor and Maidenhead</code>,
              <code>Wokingham</code>
            </li>
            <li><i>(Berkshire)</i>
              <code>Bracknell Forest</code>,
              <code>West Berkshire</code>
            </li>
            <li>
              <code>Blackburn with Darwen</code>
            </li>
            <li>
              <code>Blackpool</code>
            </li>
            <li>
              <code>Bournemouth</code>
            </li>
            <li>
              <code>Brighton and Hove</code>
            </li>
            <li>
              <code>Bristol</code>
            </li>
            <li><i>(Buckinghamshire)</i>
              <code>Chiltern</code>,
              <code>South Buckinghamshire</code>
            </li>
            <li><i>(Buckinghamshire)</i>
              <code>Aylesbury Vale</code>,
              <code>Wycombe</code>
            </li>
            <li><i>(Cambridgeshire)</i>
              <code>Cambridge</code>
            </li>
            <li><i>(Cambridgeshire)</i>
              <code>South Cambridge</code>
            </li>
            <li><i>(Cambridgeshire)</i>
              <code>East Cambridgeshire</code>,
              <code>Huntingdonshire</code>
            </li>
            <li><i>(Cambridgeshire)</i>
              <code>Fenland</code>
            </li>
            <li><i>(Cheshire)</i>
              <code>Macclesfield</code>
            </li>
            <li><i>(Cheshire)</i>
              <code>Chester</code>,
              <code>Congleton</code>,
              <code>Vale Royal</code>
            </li>
            <li><i>(Cheshire)</i>
              <code>Crewe and Nantwich</code>,
              <code>Ellesmere Port and Neston</code>
            </li>
            <li><i>(Cornwall)</i>
              <code>Isles of Scilly</code>
            </li>
            <li><i>(Cornwall)</i>
              <code>Carrick</code>
            </li>
            <li><i>(Cornwall)</i>
              <code>Caradon</code>,
              <code>Kerrier</code>,
              <code>North Cornwall</code>,
              <code>Penwith</code>,
              <code>Restormel</code>
            </li>
            <li><i>(Cumbria)</i>
              <code>South Lakeland</code>
            </li>
            <li><i>(Cumbria)</i>
              <code>Allerdale</code>,
              <code>Barrow-in-Furness</code>,
              <code>Carlisle</code>,
              <code>Copeland</code>,
              <code>Eden</code>
            </li>
            <li><code>Darlington</code></li>
            <li><code>Derby</code></li>
            <li><i>(Derbyshire)</i> <code>Derbyshire Dales</code>, <code>High Peak</code></li>
            <li><i>(Derbyshire)</i> <code>Amber Valley</code>, <code>Bolsover</code>, <code>Chesterfield</code>,
              <code>Erewash</code>, <code>North East Derbyshire</code>, <code>South</code>
              <code>Derbyshire</code>
            </li>
            <li><i>(Devon)</i> <code>South Hams</code>, <code>West Devon</code></li>
            <li><i>(Devon)</i> <code>East Devon</code>, <code>Exeter</code>, <code>Mid Devon</code>,
              <code>North Devon</code>, <code>Teignbridge</code>, <code>Torridge</code>
            </li>
            <li><i>(Dorset)</i> <code>Christchurch</code>, <code>East Dorset</code></li>
            <li><i>(Dorset)</i> <code>North Dorset</code>, <code>Purbeck</code>, <code>West Dorset</code></li>
            <li><i>(Dorset)</i> <code>Weymouth and Portland</code></li>
            <li><code>Durham</code></li>
            <li><code>East Riding of Yorkshire</code></li>
            <li><i>(East Sussex)</i> <code>Eastbourne</code></li>
            <li><i>(East Sussex)</i> <code>Wealden</code></li>
            <li><i>(East Sussex)</i> <code>Hastings</code>, <code>Lewes</code>, <code>Rother</code></li>
            <li><i>(Essex)</i> <code>Brentwood</code>, <code>Epping Forest</code></li>
            <li><i>(Essex)</i> <code>Basildon</code>, <code>Chelmsford</code>, <code>Harlow</code>,
              <code>Uttlesford</code>
            </li>
            <li><i>(Essex)</i> <code>Castle Point</code>, <code>Colchester</code>, <code>Maldon</code>,
              <code>Rochford</code>
            </li>
            <li><i>(Essex)</i> <code>Braintree</code>, <code>Tendring</code></li>
            <li><i>(Gloucestershire)</i> <code>Cheltenham</code>, <code>Cotswold</code></li>
            <li><i>(Gloucestershire)</i> <code>Forest of Dean</code>, <code>Gloucester</code>, <code>Stroud</code>,
              <code>Tewkesbury</code>
            </li>
            <li><i>(Greater London)</i> <code>Barnet</code>, <code>Bexley</code>, <code>Brent</code>,
              <code>Bromley</code>, <code>Camden</code>, <code>City of London</code>, <code>Croydon</code>,
              <code>Ealing</code>, <code>Enfield</code>
            </li>
            <li><i>(Greater London)</i> <code>Greenwich</code>, <code>Hackney</code>,
              <code>Hammersmith and Fulham</code>, <code>Haringey</code>, <code>Harrow</code>, <code>Hillingdon</code>
            </li>
            <li><i>(Greater London)</i> <code>Hounslow</code>, <code>Islington</code>,
              <code>Kensington and Chelsea</code>, <code>Kingston upon Thames</code>, <code>Lambeth</code>
            </li>
            <li><i>(Greater London)</i> <code>Lewisham</code>, <code>Merton</code>, <code>Richmond upon Thames</code>,
              <code>Southwark</code>, <code>Sutton</code>, <code>Tower Hamlets</code>
            </li>
            <li><i>(Greater London)</i> <code>Wandsworth</code>, <code>Westminster</code></li>
            <li><i>(Greater London)</i> <code>Havering</code>, <code>Newham</code>, <code>Redbridge</code>,
              <code>Waltham Forest</code>
            </li>
            <li><i>(Greater London)</i> <code>Barking and Dagenham</code></li>
            <li><i>(Greater Manchester)</i> <code>Stockport</code></li>
            <li><i>(Greater Manchester)</i> <code>Manchester</code>, <code>Trafford</code></li>
            <li><i>(Greater Manchester)</i> <code>Bolton</code>, <code>Bury</code>, <code>Oldham</code>,
              <code>Rochdale</code>, <code>Salford</code>, <code>Tameside</code>, <code>Wigan</code>
            </li>
            <li><code>Halton</code></li>
            <li><i>(Hampshire)</i> <code>Hart</code>, <code>Rushmoor</code>, <code>Winchester</code></li>
            <li><i>(Hampshire)</i> <code>Basingstoke and Deane</code>, <code>East Hampshire</code></li>
            <li><i>(Hampshire)</i> <code>Eastleigh</code>, <code>Fareham</code>, <code>Gosport</code>,
              <code>Havant</code>, <code>New Forest</code>, <code>Test Valley</code>
            </li>
            <li><code>Hartlepool</code></li>
            <li><code>Herefordshire</code></li>
            <li><i>(Hertfordshire)</i> <code>Broxbourne</code>, <code>Dacorum</code>, <code>Hertsmere</code>,
              <code>St. Albans</code>, <code>Three Rivers</code>, <code>Watford</code>, <code>Welwyn Hatfield</code>
            </li>
            <li><i>(Hertfordshire)</i> <code>East Hertfordshire</code>, <code>North Hertfordshire</code>,
              <code>Stevenage</code>
            </li>
            <li><code>Isle of Wight</code></li>
            <li><i>(Kent)</i> <code>Sevenoaks</code></li>
            <li><i>(Kent)</i> <code>Tonbridge and Malling</code>, <code>Tunbridge Wells</code></li>
            <li><i>(Kent)</i> <code>Dartford</code>, <code>Gravesham</code>, <code>Maidstone</code></li>
            <li><i>(Kent)</i> <code>Ashford</code>, <code>Canterbury</code>, <code>Dover</code>, <code>Shepway</code>,
              <code>Swale</code>, <code>Thanet</code>
            </li>
            <li><code>Kingston-upon-Hull</code></li>
            <li><i>(Lancashire)</i> <code>Ribble Valley</code></li>
            <li><i>(Lancashire)</i> <code>Burnley</code>, <code>Chorley</code>, <code>Fylde</code>,
              <code>Hyndburn</code>, <code>Lancaster</code>, <code>Pendle</code>, <code>Preston</code>,
              <code>Rossendale</code>
            </li>
            <li><i>(Lancashire)</i> <code>South Ribble</code>, <code>West Lancashire</code>, <code>Wyre</code></li>
            <li><code>Leicester</code></li>
            <li><i>(Leicestershire)</i> <code>Harborough</code></li>
            <li><i>(Leicestershire)</i> <code>Blaby</code>, <code>Charnwood</code>, <code>Hinckley and Bosworth</code>,
              <code>Melton</code>
            </li>
            <li><i>(Leicestershire)</i> <code>North West Leicestershire</code>, <code>Oadby and Wigston</code></li>
            <li><code>Lincolnshire</code></li>
            <li><code>Luton</code></li>
            <li><code>Medway</code></li>
            <li><i>(Merseyside)</i> <code>Knowsley</code>, <code>Liverpool</code>, <code>Sefton</code>,
              <code>St Helens</code>, <code>Wirral</code>
            </li>
            <li><code>Middlesbrough</code></li>
            <li><code>Milton Keynes</code></li>
            <li><code>Norfolk</code></li>
            <li><i>(Northamptonshire)</i> <code>Daventry</code>, <code>Northampton</code>,
              <code>South Northamptonshire</code>
            </li>
            <li><i>(Northamptonshire)</i> <code>Corby</code>, <code>East Northamptonshire</code>,
              <code>Kettering</code>, <code>Wellingborough</code>
            </li>
            <li><code>North East Lincolnshire</code></li>
            <li><code>North Lincolnshire</code></li>
            <li><code>North Somerset</code></li>
            <li><code>Northumberland</code></li>
            <li><i>(North Yorkshire)</i> <code>Harrogate</code></li>
            <li><i>(North Yorkshire)</i> <code>Craven</code>, <code>Hambleton</code>, <code>Richmondshire</code>,
              <code>Ryedale</code>, <code>Selby</code>
            </li>
            <li><i>(North Yorkshire)</i> <code>Scarborough</code></li>
            <li><code>Nottingham</code></li>
            <li><i>(Nottinghamshire)</i> <code>Rushcliffe</code></li>
            <li><i>(Nottinghamshire)</i> <code>Ashfield</code>, <code>Bassetlaw</code>, <code>Broxtowe</code>,
              <code>Gedling</code>, <code>Mansfield</code>, <code>Newark and Sherwood</code>
            </li>
            <li><i>(Oxfordshire)</i> <code>Oxford</code></li>
            <li><i>(Oxfordshire)</i> <code>South Oxfordshire</code>, <code>West Oxfordshire</code>,
              <code>Vale of White Horse</code>
            </li>
            <li><i>(Oxfordshire)</i> <code>Cherwell</code></li>
            <li><code>Peterborough</code></li>
            <li><code>Plymouth</code></li>
            <li><code>Poole</code></li>
            <li><code>Portsmouth</code></li>
            <li><code>Redcar and Cleveland</code></li>
            <li><code>Rutland</code></li>
            <li><i>(Shropshire)</i> <code>Bridgnorth</code>, <code>Shrewsbury and Atcham</code>,
              <code>South Shropshire</code>
            </li>
            <li><i>(Shropshire)</i> <code>Oswestry</code>, <code>North Shropshire</code></li>
            <li><i>(Somerset)</i> <code>Taunton Deane</code></li>
            <li><i>(Somerset)</i> <code>Mendip</code>, <code>Sedgemoor</code>, <code>South Somerset</code>,
              <code>West Somerset</code>
            </li>
            <li><code>Southampton</code></li>
            <li><code>Southend-on-Sea</code></li>
            <li><code>South Gloucestershire</code></li>
            <li><i>(South Yorkshire)</i> <code>Sheffield</code></li>
            <li><i>(South Yorkshire)</i> <code>Barnsley</code>, <code>Doncaster</code>, <code>Rotherham</code></li>
            <li><i>(Staffordshire)</i> <code>Lichfield</code></li>
            <li><i>(Staffordshire)</i> <code>Cannock Chase</code>, <code>East Staffordshire</code>,
              <code>Newcastle-under-Lyme</code>, <code>South Staffordshire</code>
            </li>
            <li><i>(Staffordshire)</i> <code>Stafford</code>, <code>Staffordshire Moorlands</code>,
              <code>Tamworth</code>
            </li>
            <li><code>Stockton-on-Tees</code></li>
            <li><code>Stoke-on-Trent</code></li>
            <li><i>(Suffolk)</i> <code>St Edmundsbury</code></li>
            <li><i>(Suffolk)</i> <code>Babergh</code>, <code>Forest Heath</code>, <code>Ipswich</code>,
              <code>Mid Suffolk</code>, <code>Suffolk Coastal</code>
            </li>
            <li><i>(Suffolk)</i> <code>Waveney</code></li>
            <li><code>Surrey</code></li>
            <li><code>Swindon</code></li>
            <li><code>Telford and the Wrekin</code></li>
            <li><code>Thurrock</code></li>
            <li><code>Torbay</code></li>
            <li><code>Tyne and Wear</code></li>
            <li><code>Warrington</code></li>
            <li><i>(Warwickshire)</i> <code>Stratford-upon-Avon</code></li>
            <li><i>(Warwickshire)</i> <code>Warwick</code></li>
            <li><i>(Warwickshire)</i> <code>North Warwickshire</code>, <code>Nuneaton and Bedworth</code>,
              <code>Rugby</code>
            </li>
            <li><i>(West Midlands)</i> <code>Solihull</code></li>
            <li><i>(West Midlands)</i> <code>Birmingham</code></li>
            <li><i>(West Midlands)</i> <code>Coventry</code></li>
            <li><i>(West Midlands)</i> <code>Dudley</code>, <code>Sandwell</code>, <code>Walsall</code>,
              <code>Wolverhampton</code>
            </li>
            <li><i>(West Sussex)</i> <code>Adur</code>, <code>Chichester</code>, <code>Crawley</code>,
              <code>Horsham</code>, <code>Mid Sussex</code>
            </li>
            <li><i>(West Sussex)</i> <code>Arun</code>, <code>Worthing</code></li>
            <li><i>(West Yorkshire)</i> <code>Leeds</code></li>
            <li><i>(West Yorkshire)</i> <code>Bradford</code>, <code>Calderdale</code>, <code>Kirklees</code>,
              <code>Wakefield</code>
            </li>
            <li><i>(Wiltshire)</i> <code>Salisbury</code></li>
            <li><i>(Wiltshire)</i> <code>Kennett</code>, <code>North Wiltshire</code></li>
            <li><i>(Wiltshire)</i> <code>West Wiltshire</code></li>
            <li><i>(Worcestershire)</i> <code>Malvern Hills</code>, <code>Worcester</code>, <code>Wychavon</code></li>
            <li><i>(Worcestershire)</i> <code>Bromsgrove</code>, <code>Redditch</code></li>
            <li><i>(Worcestershire)</i> <code>Wyre Forest</code></li>
            <li><code>York</code></li>
          </ul>
        </td>
      </tr>
      <tr>
        <td>January 1999 Value</td>
        <td>The property value as at January 1999. Used for Formula Rent compliance calculations in Social Housing.</td>
        <td>Number</td>
        <td><i>No</i></td>
        <td>
          <p>If provided then the value must be equal to or greater than zero.</p>
          <p>If not provided, the value will be calculated based on Last Valuation (if available) or Market Value
            Aggregation, indexed by CPI to January 1999.</p>
        </td>
      </tr>
      <tr>
        <td>Responsive Open Repairs</td>
        <td>The current annual cost of responsive (reactive) repair works for the property.</td>
        <td>Number</td>
        <td><i>No</i></td>
        <td>If provided then the value must be equal to or greater than zero.</td>
      </tr>
      <tr>
        <td>Responsive Forecast Repairs</td>
        <td>Forecast annual cost of responsive (reactive) repair works for the property.</td>
        <td>Number</td>
        <td><i>No</i></td>
        <td>If provided then the value must be equal to or greater than zero.</td>
      </tr>
      <tr>
        <td>Cyclical Gas Costs</td>
        <td>Annual cost of cyclical gas servicing and maintenance.</td>
        <td>Number</td>
        <td><i>No</i></td>
        <td>If provided then the value must be equal to or greater than zero.</td>
      </tr>
      <tr>
        <td>Cyclical Fire Costs</td>
        <td>Annual cost of cyclical fire safety inspections and maintenance.</td>
        <td>Number</td>
        <td><i>No</i></td>
        <td>If provided then the value must be equal to or greater than zero.</td>
      </tr>
      <tr>
        <td>Cyclical Electrical Costs</td>
        <td>Annual cost of cyclical electrical inspections and maintenance.</td>
        <td>Number</td>
        <td><i>No</i></td>
        <td>If provided then the value must be equal to or greater than zero.</td>
      </tr>
      <tr>
        <td>Cyclical Legionella Costs</td>
        <td>Annual cost of cyclical legionella risk assessments and water treatment.</td>
        <td>Number</td>
        <td><i>No</i></td>
        <td>If provided then the value must be equal to or greater than zero.</td>
      </tr>
      <tr>
        <td>Cyclical Management Costs</td>
        <td>Annual cost of cyclical property management activities.</td>
        <td>Number</td>
        <td><i>No</i></td>
        <td>If provided then the value must be equal to or greater than zero.</td>
      </tr>
      <tr>
        <td>Cyclical Other Costs</td>
        <td>Annual cost of any other cyclical maintenance not covered by specific categories.</td>
        <td>Number</td>
        <td><i>No</i></td>
        <td>If provided then the value must be equal to or greater than zero.</td>
      </tr>
      <tr>
        <td>Planned Roof Costs</td>
        <td>Annual planned investment cost for roof works.</td>
        <td>Number</td>
        <td><i>No</i></td>
        <td>If provided then the value must be equal to or greater than zero.</td>
      </tr>
      <tr>
        <td>Planned Kitchen Costs</td>
        <td>Annual planned investment cost for kitchen replacement or refurbishment.</td>
        <td>Number</td>
        <td><i>No</i></td>
        <td>If provided then the value must be equal to or greater than zero.</td>
      </tr>
      <tr>
        <td>Planned Bathroom Costs</td>
        <td>Annual planned investment cost for bathroom replacement or refurbishment.</td>
        <td>Number</td>
        <td><i>No</i></td>
        <td>If provided then the value must be equal to or greater than zero.</td>
      </tr>
      <tr>
        <td>Planned Structural Costs</td>
        <td>Annual planned investment cost for structural works.</td>
        <td>Number</td>
        <td><i>No</i></td>
        <td>If provided then the value must be equal to or greater than zero.</td>
      </tr>
      <tr>
        <td>Planned Window Costs</td>
        <td>Annual planned investment cost for window replacement.</td>
        <td>Number</td>
        <td><i>No</i></td>
        <td>If provided then the value must be equal to or greater than zero.</td>
      </tr>
      <tr>
        <td>Planned Door Costs</td>
        <td>Annual planned investment cost for door replacement.</td>
        <td>Number</td>
        <td><i>No</i></td>
        <td>If provided then the value must be equal to or greater than zero.</td>
      </tr>
      <tr>
        <td>Planned Heating Costs</td>
        <td>Annual planned investment cost for heating system replacement or upgrade.</td>
        <td>Number</td>
        <td><i>No</i></td>
        <td>If provided then the value must be equal to or greater than zero.</td>
      </tr>
      <tr>
        <td>Planned Electrics Costs</td>
        <td>Annual planned investment cost for electrical system replacement or upgrade.</td>
        <td>Number</td>
        <td><i>No</i></td>
        <td>If provided then the value must be equal to or greater than zero.</td>
      </tr>
      <tr>
        <td>Planned Other Costs</td>
        <td>Annual planned investment cost for any other works not covered by specific categories.</td>
        <td>Number</td>
        <td><i>No</i></td>
        <td>If provided then the value must be equal to or greater than zero.</td>
      </tr>
      <tr>
        <td>Service Charge</td>
        <td>The weekly service charge amount for the property.</td>
        <td>Number</td>
        <td><i>No</i></td>
        <td>If provided then the value must be equal to or greater than zero.</td>
      </tr>
      <tr>
        <td>Supported or Sheltered Housing</td>
        <td>Indicates whether the property is supported or sheltered housing.</td>
        <td>Boolean</td>
        <td><i>No</i></td>
        <td>Use <code>true</code> or <code>false</code>.</td>
      </tr>
    </tbody>
  </table>
</div>
